// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as EditSmsTemplateApiModel from "../api-model/EditSmsTemplateApiModel.bs.js";

function apiModelToState(res) {
  return {
          status_code: res.status_code,
          status: res.status
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(EditSmsTemplateApiModel.t_decode(json), "EditSmsTemplateEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
